import axios from 'axios';
import React,{useEffect} from 'react';
import { base_url } from '../utilities';
import { useState } from 'react';
import Cookies from 'js-cookie';

const BusinessData = React.createContext()
const BusinessDataUserAPIFile = ({children}) => {
const [businessdataUser, setBusinessdataUser] = useState([])

let bus_Id =  Cookies.get("business_id")
    // useEffect(() => {
      
    //  if(bus_Id){   axios
    //       .post(base_url + "business-master/get_business_data_user", {
    //         user_id: Cookies.get("user_id"),
    //       })
    //       .then((res) => {
    //         setBusinessdataUser(res.data.data[0]);
    //       })}
       
    //   }, [bus_Id]);
    return (
        <BusinessData.Provider value={businessdataUser}>
            {children}
        </BusinessData.Provider>
    );
};

export {BusinessDataUserAPIFile, BusinessData};